// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-x0a42t","actionsContainer":"actionsContainer-vXNvWh","title":"title-ui58_9","menuButton":"menuButton-Z24acE","redTextColor":"redTextColor-RRbr8x"};